var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssignToIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1708_9556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.01126 9.92343V11.1727C8.6352 11.0405 8.23058 10.9686 7.80901 10.9686C5.81705 10.9686 4.20225 12.5747 4.20225 14.556H3C3 11.9143 5.15307 9.77276 7.80901 9.77276C8.22415 9.77276 8.62702 9.82508 9.01126 9.92343ZM7.80901 9.17485C5.81628 9.17485 4.20225 7.56948 4.20225 5.58743C4.20225 3.60537 5.81628 2 7.80901 2C9.80174 2 11.4158 3.60537 11.4158 5.58743C11.4158 7.56948 9.80174 9.17485 7.80901 9.17485ZM7.80901 7.97905C9.1375 7.97905 10.2135 6.9088 10.2135 5.58743C10.2135 4.26606 9.1375 3.19581 7.80901 3.19581C6.48052 3.19581 5.4045 4.26606 5.4045 5.58743C5.4045 6.9088 6.48052 7.97905 7.80901 7.97905ZM11.2913 13.3089L13.4166 11.195L14.2667 12.0406L11.2913 15L9.16599 12.8861L10.0161 12.0406L11.2913 13.3089Z",
    fill: "#7E8392"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1708_9556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignToIcon);
export default __webpack_public_path__ + "static/media/assign-to-icon.47d27fe6c7631d2cffcfe595379c3819.svg";
export { ForwardRef as ReactComponent };